export default __webpack_public_path__ + "static/media/szentendre.5ab212df.png";